import { Pipe, PipeTransform } from '@angular/core';
import { Dictionary } from '@ngrx/entity';

@Pipe({
    name: 'listHasString',
    standalone: true
})
export class ListHasStringPipe implements PipeTransform {
  transform(list: string[], str: string): boolean {
    if (!list) return false
    return list.includes(str)
  }
}
